import { render, staticRenderFns } from "./ManageEmailPage.vue?vue&type=template&id=b752f950&scoped=true&"
import script from "./ManageEmailPage.vue?vue&type=script&lang=ts&"
export * from "./ManageEmailPage.vue?vue&type=script&lang=ts&"
import style0 from "./ManageEmailPage.vue?vue&type=style&index=0&id=b752f950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b752f950",
  null
  
)

export default component.exports